export const BIGGEST_WINNER = {
  prefix: "$",
  value: 7680.84,
  suffix: "",
  change: 0,
  changeSuffix: "",
  decimals: 2,
};
